import { useEffect, useState } from 'react';
import { axiosAPI } from 'utils';

export const filterVisibleTemplates = (templates, hideMathRods) =>
  templates.filter(template => !hideMathRods || template.alias !== 'MATH_RODS');

// Keep the full catalog available for playing/editing already created activities.
export default function useVisibleActivityTemplates(templates, active = true) {
  const [hideMathRods, setHideMathRods] = useState(true);
  useEffect(() => {
    if (!active) return undefined;
    let mounted = true;
    let request = 0;
    const refresh = async () => {
      const id = ++request;
      try {
        const result = await axiosAPI.get('/api/common/activity-template-visibility', {
          params: { _: Date.now() },
        });
        if (mounted && id === request) setHideMathRods(result.data.hideMathRods !== false);
      } catch (error) {
        if (mounted && id === request) setHideMathRods(true);
      }
    };
    setHideMathRods(true);
    refresh();
    window.addEventListener('focus', refresh);
    window.addEventListener('activity-template-visibility-changed', refresh);
    const timer = window.setInterval(refresh, 30000);
    return () => {
      mounted = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener('activity-template-visibility-changed', refresh);
    };
  }, [active]);
  return filterVisibleTemplates(templates, hideMathRods);
}
